import { Component, OnInit, Input, HostListener, OnDestroy } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { WindowRefService, ApiService, TrackingService, PciCardService } from '@app/core';
import { TranslateService } from '@ngx-translate/core';
import { Router } from "@angular/router";

const routes = {
    saveResaPci: '/save-resa-pci',
};
const GTMCheckoutProcess = {
    step_3: 3,
    step_4: 4,
    payment_method: 'PCI'
}

@Component({
    selector: 'app-pci-form',
    templateUrl: './pci-form.component.html',
    styleUrls: ['./pci-form.component.scss']
})
export class PciFormComponent implements OnInit, OnDestroy {
    private readonly _ROUTE_VIEWRESA: string = '/checkprice/viewresa';
    @Input() ruid: string;
    @Input() infos: any;
    @Input() saveRoute: string;
    url: SafeResourceUrl;
    isLoadingCardPay: boolean = false;

    constructor(
        private winRef: WindowRefService,
        private translate: TranslateService,
        private apiService: ApiService,
        private router: Router,
        private trackingService: TrackingService,
        private pciCardService: PciCardService,
    ) { }

    ngOnInit() {
        this.url = this.pciCardService.getUrl(this.infos);
    }

    //https://developers.pcibooking.net/docs/set-up-postmessage-mechanism
    @HostListener('window:message', ['$event'])
    onMessage(e: any) {
        let host = 'https://service.pcibooking.net/'
        let originDomain = e.origin.replace("http://", "").replace("https://", "");
        let postMessageOrigin = host.replace("http://", "").replace("https://", "").toLowerCase();
        if (postMessageOrigin.endsWith('/'))
            postMessageOrigin = postMessageOrigin.substring(0, postMessageOrigin.length - 1);


        if (originDomain.toLowerCase() === postMessageOrigin) {
            if (e.data == 'ready') {
                //console.log("Messaging Log: " + e.data);
            } else if (e.data == 'valid') {
                //continueSubmitReservationAndThenCardIframe(e);
                //console.log('isvalid', e);
            } else if (e.data[0] === "{") {
                //console.log("Messaging Log: ");
                //console.log(JSON.parse(e.data));
            } else if ((typeof e.data === 'string' || e.data instanceof String) && e.data.indexOf("frameDimensionsChanged") === 0) {
                //var objectParts = e.data.split(':');
                //console.log("Messaging Log: " + e.data);
            } else {
                /*
                this._createResa({
                    cardToken: "https://service.pcibooking.net/api/payments/paycard/a695e258b7304db3886ee7f8db1059c2",
                    cardType: "Visa",
                    cvv: "***",
                    expiration: "062023",
                    maskedCardNumber: "444433******1111",
                    messageType: "CardSubmitSuccess",
                    nameOnCard: "THHT"
                })
                console.log(e);
                //*/
                switch (e.data.messageType) {
                    /*
                    case "CardSubmitFailure":
                        this.translate.get('static.oups...uneerreuresestproduite,mercipourvotrecomprehenssion').subscribe((res: string) => {
                            alert(res); console.log(e.data);
                            this.winRef.nativeWindow.location.reload();
                        })
                        break;
                        //*/
                    case "CardSubmitSuccess":
                        this._createResa(e.data)
                        break;

                    default:
                        this.translate.get('static.oups...uneerreuresestproduite,mercipourvotrecomprehenssion').subscribe((res: string) => {
                            alert(res); console.log(e.data);

                            //this.winRef.nativeWindow.location.reload();
                            this.winRef.nativeWindow.history.back();
                        })
                        this.apiService.post('/error-card', { 'data': e.data, 'infos': this.infos }).subscribe();
                        break;
                }

            }
        }
    }

    ngOnDestroy() {

    }

    _createResa(data: { cardToken: string, cardType: string, cvv: string, expiration: string, maskedCardNumber: string, messageType: string, nameOnCard: string, }): void {
        let params = { uid: this.ruid, ...data };
        this.isLoadingCardPay = true;
        this.trackingService.chekoutProcess(GTMCheckoutProcess.step_3, GTMCheckoutProcess.payment_method);
        this.apiService.post(this.saveRoute, params).subscribe(
            rep => {
                if (rep.status === 1) {
                    this._redirectToViewResa();
                    this.trackingService.chekoutProcess(GTMCheckoutProcess.step_4, null);
                } else {
                    this.translate.get('static.oups...uneerreuresestproduite,mercipourvotrecomprehenssion').subscribe((res: string) => {
                        alert(res); console.log(res);
                    })
                    this.apiService.post('/error-card', { 'data': rep, 'infos': this.infos }).subscribe();
                }
                this.isLoadingCardPay = false;
            },
            err => {
                console.log('Error', err);
                this.translate.get('static.oups...uneerreuresestproduite,mercipourvotrecomprehenssion').subscribe((res: string) => {
                    alert(res); console.log(res);
                })
                this.apiService.post('/error-card', { 'data': err, 'infos': this.infos }).subscribe();
                this.isLoadingCardPay = false;
            }
        );
    }

    private _redirectToViewResa(): void {
        this.router.navigate([this._ROUTE_VIEWRESA, this.ruid]);
    }
}
